import { createSelector } from 'reselect';
import { RootState } from 'store/types';

import { OnboardingState } from './slice';

export const selectOnboarding = (state: RootState): OnboardingState => state.patientOnboarding;
export const selectOnboardingState = createSelector(selectOnboarding, (onboarding) => onboarding);
